module.exports = {"path":"/404.html","body":"<h1 id=\"page-not-found\">Page Not Found</h1>\n<p>Oops! This link appears to be broken.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 561
// module chunks = 0